<template>
    <transition>
        <router-view/>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Register',
    mounted() {
        !this.isUSA && this.$store.dispatch('cookies/mountPrimer');
        this.$store.dispatch('cookies/mountStripe');
    },
    computed: {
        ...mapGetters({
            isUSA: 'localisation/isUSA',
        }),
    },
};
</script>
